import { getBaseUrl } from "util/getBaseUrl";

export interface PageSection {
  id: number;
  page_id: number;
  submission_id: string;
  content: string;
  similarity: number;
  filename: string;
  title: string | null;
}

export interface ChatResponse {
  chat_response: string;
  page_sections: PageSection[];
}

export interface GetChatResponseProps {
  query: string;
  system_message: string;
  user_message: string;
  submission_ids: string[];
  use_all_uploads: boolean;
  chatbot_id: string;
  conversation_history: string[];
}

export const useAIChat = () => {
  const getChatResponse = async ({ query, system_message, user_message, use_all_uploads, submission_ids, chatbot_id, conversation_history }: GetChatResponseProps): Promise<ChatResponse> => {
    const response = await fetch(`${getBaseUrl()}/api/chatbot`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query, system_message, user_message, use_all_uploads, submission_ids, chatbot_id, conversation_history }),
    });

    const result: ChatResponse = await response.json();

    return result;
  }

  return { getChatResponse }
}